import { z } from 'zod';

/**
 * Category form validation, mirroring the Admin API: both names required,
 * 50 characters at most (AdminCategoryRequest). Input type === output type
 * (no transforms), as the brand schema explains.
 */
const name = (label: string) =>
  z
    .string()
    .trim()
    .min(1, `${label} is required.`)
    .max(50, `${label} must be 50 characters or fewer.`);

export const categorySchema = z.object({
  nameEn: name('English name'),
  nameAr: name('Arabic name'),
  /** Used on create only; the status changes through its own confirmed action. */
  isActive: z.boolean(),
});

export type CategoryFormValues = z.infer<typeof categorySchema>;
